module.exports = __webpack_public_path__ + "static/media/lt.b3d165c8.svg";